import * as actions from "../../constants";
import { IFilterMenu, IMenuFilters } from "../../types/wizard-types";

export const filterMenu = (filters: IMenuFilters): IFilterMenu => ({
  type: actions.ACTION_FILTER_ADD_FROM_MENU,
  payload: filters,
});
